import { render, staticRenderFns } from "./HarvestQuality.vue?vue&type=template&id=3a8a2060"
import script from "./HarvestQuality.vue?vue&type=script&lang=js"
export * from "./HarvestQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports